var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExcluirVermelho(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2069 1.82706H9.13517V0.480789C9.13517 0.209803 8.91659 0 8.64562 0C8.61933 0 8.60179 0.00877768 8.59324 0.0175353C8.58446 0.00877768 8.56693 0 8.55817 0H3.68901H3.65414H3.61908C3.34811 0 3.13831 0.209803 3.13831 0.480789V1.82708H1.05779C0.463257 1.82708 0 2.29033 0 2.88487V3.65416V4.61572H0.917915V14.4676C0.917915 15.0621 1.37241 15.5166 1.96695 15.5166H10.2978C10.8923 15.5166 11.3556 15.0621 11.3556 14.4676V4.61572H12.2647V3.65416V2.88487C12.2647 2.29033 11.8013 1.82706 11.2069 1.82706ZM4.09986 0.961557H8.16486V1.82706H4.09986V0.961557ZM10.3852 14.4676C10.3852 14.5289 10.359 14.555 10.2978 14.555H1.96695C1.90578 14.555 1.87949 14.5289 1.87949 14.4676V4.6157H10.3852V14.4676ZM11.2944 3.65414H0.970322V2.88485C0.970322 2.82367 0.996613 2.78862 1.05778 2.78862H11.2069C11.2681 2.78862 11.2944 2.82367 11.2944 2.88485V3.65414H11.2944Z",
    fill: "#930035"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.89355,
    y: 5.74414,
    width: 0.970315,
    height: 7.95487,
    fill: "#930035"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.65625,
    y: 5.74414,
    width: 0.970315,
    height: 7.95487,
    fill: "#930035"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.41797,
    y: 5.74414,
    width: 0.970315,
    height: 7.95487,
    fill: "#930035"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.2647,
    height: 15.5166,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.2647,
    height: 15.5166,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcluirVermelho);
export default __webpack_public_path__ + "static/media/excluir-vermelho.5901cb1ae478b3d886ee52791730a18c.svg";
export { ForwardRef as ReactComponent };